__turbopack_context__.v({
  "active": "BottomBar-module-scss-module__942grq__active",
  "bottomBar": "BottomBar-module-scss-module__942grq__bottomBar",
  "icon": "BottomBar-module-scss-module__942grq__icon",
});
